import type { SystemStyleObject } from '@hivewatch/dark'

/**
 * Shared typography for every breadcrumb crumb (name, floor, facility) — the
 * incident-drawer DarkHeader name treatment. Only the color differs (the name
 * is primary text, floor/facility are links), which the breadcrumb resolves.
 */
export const crumbStyles: SystemStyleObject = {
  fontFamily: "'Soehne Kraftig', sans-serif",
  fontSize: '16px',
  fontWeight: '500',
  lineHeight: '24px',
  maxWidth: '175px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: 'inline-block',
}
